import axios from 'axios';
import { API_URL } from './baseApi';

export const bannersApi = {
  getBannersForCategory: async (categoryId: number) => {
    return await axios.get(`${API_URL}/v3/banners?category_id=${categoryId}`);
  },
};
